import { render, staticRenderFns } from "./PrestaShopIcon.vue?vue&type=template&id=e59066a2&scoped=true"
import script from "./PrestaShopIcon.vue?vue&type=script&lang=js"
export * from "./PrestaShopIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59066a2",
  null
  
)

export default component.exports